import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllGroups = async ({ companyCode, isTrue=true }) => {
  if (!companyCode) return [];
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAllGroup}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getGroupById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAllGroup}?isAll=false&CompanyCode=${companyCode}&groupCode=${code}`
  );
  return data;
};

const insertGroup = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.InsertGroup, input);
  return data;
};

const updateGroup = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.UpdateGroup, input);
  return data;
};

const deleteGroup = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.DeleteGroup}?CompanyCode=${companyCode}&GroupId=${code}`
  );
  return data;
};

export const useGetGroupsQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAllGroup],
    queryFn: () => getAllGroups(input),
     refetchOnWindowFocus: false,
    
  });
};

export const useGetGroupByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAllGroup],
    queryFn: () => getGroupById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertGroupMutation = () => {
  return useMutation({
    mutationFn: insertGroup,
  });
};

export const useUpdateGroupMutation = () => {
  return useMutation({
    mutationFn: updateGroup,
  });
};

export const useDeleteGroupMutation = () => {
  return useMutation({
    mutationFn: deleteGroup,
  });
};
